import moment from 'moment';

export const formatYearAndMonth = (value: string | undefined, format = 'MMM/YYYY') => {
  if (!value) return 'N/A';
  console.log(value, 'format value');
  return moment(value, 'YYYY-MM').format(format);
};
